import React from 'react'
import IconSmartSchedulingSvg from 'public/assets/img/icon-smart-scheduling.svg'

export const IconSmartScheduling: React.FC = () => {
  return (
    <img
      className="element-icon"
      aria-label="Icon Smart Scheduling"
      src={IconSmartSchedulingSvg}
      alt="Smart scheduling"
    />
  )
}
